import React, { useState } from "react";

const normalizeUrl = (value) => {
    const trimmed = value.trim();
    if (!trimmed) return null;

    const withScheme = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;

    try {
        const parsed = new URL(withScheme);
        // Only http(s) — keeps javascript:/data: out of the iframe src
        if (parsed.protocol !== "http:" && parsed.protocol !== "https:") return null;
        return parsed.href;
    } catch (e) {
        return null;
    }
};

const WebViewDemo = () => {
    const [input, setInput] = useState("");
    const [src, setSrc] = useState("");
    const [error, setError] = useState("");
    const [reloadKey, setReloadKey] = useState(0);

    const handleSubmit = (e) => {
        e.preventDefault();
        const url = normalizeUrl(input);

        if (!url) {
            setError("Enter a valid http(s) URL, e.g. https://example.com");
            setSrc("");
            return;
        }

        setError("");
        setSrc(url);
        setReloadKey((k) => k + 1);
    };

    const handleClear = () => {
        setInput("");
        setSrc("");
        setError("");
    };

    return (
        <div className="container py-4">
            <h3 className="mb-3">WebView Demo</h3>

            <form className="row g-2 align-items-start mb-2" onSubmit={handleSubmit}>
                <div className="col">
                    <input
                        type="text"
                        className={`form-control ${error ? "is-invalid" : ""}`}
                        placeholder="Paste a URL (https://example.com)"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                    />
                    {error && <div className="invalid-feedback">{error}</div>}
                </div>
                <div className="col-auto">
                    <button type="submit" className="btn btn-primary">
                        Load
                    </button>
                </div>
                <div className="col-auto">
                    <button type="button" className="btn btn-outline-secondary" onClick={handleClear}>
                        Clear
                    </button>
                </div>
            </form>

            {src && (
                <div className="text-muted small mb-2">
                    Showing: <span className="text-break">{src}</span>
                </div>
            )}

            <div className="border rounded overflow-hidden bg-light" style={{ height: "75vh" }}>
                {src ? (
                    <iframe
                        key={reloadKey}
                        title="webview"
                        src={src}
                        style={{ width: "100%", height: "100%", border: 0 }}
                        sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
                        referrerPolicy="no-referrer"
                    />
                ) : (
                    <div className="d-flex h-100 align-items-center justify-content-center text-muted">
                        Paste a URL above and hit Load
                    </div>
                )}
            </div>

            <div className="text-muted small mt-2">
                Note: sites that send <code>X-Frame-Options</code> or a restrictive{" "}
                <code>frame-ancestors</code> CSP (Google, Facebook, most banks) will refuse to render
                here — that's the site blocking framing, not a bug in this page.
            </div>
        </div>
    );
};

export default WebViewDemo;
